<template>
  <div id="app" class="parallax">
    <router-view name="header"></router-view>
    <main>
      <fade-transition origin="center" mode="out-in" :duration="250">
        <router-view />
      </fade-transition>
    </main>
    <router-view name="footer"></router-view>
    <CookieNotice/>
    <!-- <BanerFlotante image="https://content.notin.es/images/Tarjeta_navidad.png"/> -->
  </div>
</template>

<script>
import { FadeTransition } from "vue2-transitions";
import CookieNotice from '@/views/components/CookieNotice.vue'
export default {
  components: {
    FadeTransition,
    CookieNotice
    // BanerFlotante: () => import('@/components/BanerFlotante')
  },
  methods:{
  }
};
</script>
